import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FiMessageCircle, FiPhone, FiX } from 'react-icons/fi';
import { FaWhatsapp } from 'react-icons/fa';

const FloatingContact = () => {
    const [isExpanded, setIsExpanded] = useState(false);

    const contactButtons = [
        {
            icon: FaWhatsapp,
            label: 'WhatsApp',
            href: 'https://wa.me/97366752929',
            bgColor: 'bg-green-500 hover:bg-green-600',
            delay: 0.1,
        },
        {
            icon: FiPhone,
            label: 'Call Us',
            href: 'tel:+97317701616',
            bgColor: 'bg-primary-500 hover:bg-primary-600',
            delay: 0.2,
        },
    ];

    return (
        <div className="fixed bottom-6 ltr:right-6 rtl:left-6 z-50 flex flex-col ltr:items-end rtl:items-start gap-3">
            {/* Expanded Contact Options */}
            <AnimatePresence>
                {isExpanded && (
                    <>
                        {contactButtons.map((button, index) => (
                            <motion.a
                                key={button.label}
                                href={button.href}
                                target={button.label === 'WhatsApp' ? '_blank' : '_self'}
                                rel="noopener noreferrer"
                                initial={{ opacity: 0, scale: 0.5, y: 20 }}
                                animate={{ opacity: 1, scale: 1, y: 0 }}
                                exit={{ opacity: 0, scale: 0.5, y: 20 }}
                                transition={{ duration: 0.2, delay: button.delay }}
                                className={`flex items-center gap-3 px-4 py-3 ${button.bgColor} text-white rounded-full shadow-lg transition-all duration-300 hover:shadow-xl group`}
                            >
                                <span className="text-sm font-medium whitespace-nowrap">{button.label}</span>
                                <button.icon size={22} />
                            </motion.a>
                        ))}
                    </>
                )}
            </AnimatePresence>

            {/* Main Toggle Button */}
            <motion.button
                onClick={() => setIsExpanded(!isExpanded)}
                whileHover={{ scale: 1.1 }}
                whileTap={{ scale: 0.95 }}
                className={`w-14 h-14 rounded-full shadow-lg flex items-center justify-center transition-all duration-300 ${isExpanded
                    ? 'bg-gray-700 hover:bg-gray-800'
                    : 'bg-accent-500 hover:bg-accent-600'
                    } text-white`}
                aria-label={isExpanded ? 'Close contact options' : 'Open contact options'}
            >
                <AnimatePresence mode="wait">
                    {isExpanded ? (
                        <motion.div
                            key="close"
                            initial={{ rotate: -90, opacity: 0 }}
                            animate={{ rotate: 0, opacity: 1 }}
                            exit={{ rotate: 90, opacity: 0 }}
                            transition={{ duration: 0.2 }}
                        >
                            <FiX size={24} />
                        </motion.div>
                    ) : (
                        <motion.div
                            key="open"
                            initial={{ rotate: 90, opacity: 0 }}
                            animate={{ rotate: 0, opacity: 1 }}
                            exit={{ rotate: -90, opacity: 0 }}
                            transition={{ duration: 0.2 }}
                            className="relative"
                        >
                            <FiMessageCircle size={24} />
                            {/* Pulse animation */}
                            <span className="absolute -top-1 -right-1 w-3 h-3 bg-green-400 rounded-full animate-ping"></span>
                            <span className="absolute -top-1 -right-1 w-3 h-3 bg-green-400 rounded-full"></span>
                        </motion.div>
                    )}
                </AnimatePresence>
            </motion.button>
        </div>
    );
};

export default FloatingContact;
